import Axios from '../lib/axios'
import StorageService from '../services/storage'
import AxiosForMobile from '../lib/axios_for_mobile'

class UserService {
  async index () {
    const result = await Axios.authenticated().get('/users', {})
    return result
  }

  async edit (id) {
    const result = await Axios.authenticated().get(`/users/${id}`, {})
    return result
  }

  async me () {
    const result = await Axios.authenticated().get('/users/me')
    StorageService.setItem('user', JSON.stringify(result.data))
    return result
  }

  async meForMobile () {
    const result = await AxiosForMobile.authenticated().get('/b/users/me')
    StorageService.setItem('user', JSON.stringify(result.data))
    return result
  }

  async update (user) {
    const result = await Axios.authenticated().put(
      `/users/me`,
      user
    )
    return result
  }

  async create (user) {
    const result = await Axios.authenticated().post(
      `/users/me`,
      user
    )
    return result
  }

  async updateUser (user) {
    const result = await Axios.authenticated().put(
      `/users/${user.id}`,
      user
    )
    return result
  }

  async createUser (user) {
    const result = await Axios.authenticated().post(
      `/users`,
      user
    )
    return result
  }
}

export default new UserService()
